/**
 * @generated SignedSource<<46a2f45a58e9a836767b5a7456d01127>>
 * @relayHash b3b9c0def35d3ac5fbea0bf6df7901f8
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID b3b9c0def35d3ac5fbea0bf6df7901f8

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "City",
    "kind": "LinkedField",
    "name": "cities",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "city",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "postalCode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSearchCitiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSearchCitiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "b3b9c0def35d3ac5fbea0bf6df7901f8",
    "metadata": {},
    "name": "useSearchCitiesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "42ae4822e70bc0bd0993c45c45dd7188";

export default node;
